import { ChangeEvent, FC } from 'react'
import { useTranslation } from 'next-i18next'

import { Select } from 'ui'

import { MARKET_PREFERENCE } from '../../services/context/AuthContext'

const MarketPreferenceSelect: FC<{
  value?: MARKET_PREFERENCE
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
}> = ({ value, onChange }) => {
  const { t } = useTranslation('auth')

  // Markets alphabetical; "Other" always last (not alphabetical) per product.
  const marketPreferences = [
    {
      label: t('sign-up-form.market-preference-sources.atlanta-georgia'),
      value: MARKET_PREFERENCE.ATLANTA_GA,
    },
    {
      label: t('sign-up-form.market-preference-sources.charlotte'),
      value: MARKET_PREFERENCE.CHARLOTTE,
    },
    {
      label: t(
        'sign-up-form.market-preference-sources.greensboro-winston-salem'
      ),
      value: MARKET_PREFERENCE.GREENSBORO_WINSTON_SALEM,
    },
    {
      label: t('sign-up-form.market-preference-sources.raleigh-durham'),
      value: MARKET_PREFERENCE.RALEIGH_DURHAM,
    },
    {
      label: t('sign-up-form.market-preference-sources.other'),
      value: MARKET_PREFERENCE.OTHER,
    },
  ]

  return (
    <Select
      id="where-buying"
      className="pt-8"
      value={value}
      required
      items={marketPreferences.map((market) => ({
        title: market.label,
        value: market.value,
      }))}
      label={t('sign-up-form.market-preference-label')}
      placeholder="Select Option"
      onChange={onChange}
    />
  )
}

export default MarketPreferenceSelect
